import { useContext } from "react";
import { defaultColumnColors } from '../EmissoraColor/EmissoraColor';
import { ChannelsContext } from '../../../context/ChannelsContext';

export function ReportChartBar({
    customColors,
    audience,
    qtyMinutes,
}) {

    const RootComponent = document.getElementById("root");
    const { channels } = useContext(ChannelsContext);

    const pUiScreenWidth = parseFloat(RootComponent != undefined ? getComputedStyle(RootComponent).width : '0');
    const pUiScreenHeight = parseFloat(RootComponent != undefined ? getComputedStyle(RootComponent).height : '0');
    
    const chartTopPadding = 30;
    let scaleRating = 5;
    const nMinutes = 5;
    const nMaxEmissoras = 5

    const pRowsHeaders = audience != null && audience.length > 0 ? audience.map(row => row.slice(0, 4)) : [];
    const pRowsColumns = audience != null && audience.length > 0 ? audience[0].slice(4).map((_, i) => audience.map(row => row[i + 4] === '0' ? '-' : row[i + 4]).reverse()) : [];    
    const pChartHeight = (pUiScreenHeight - chartTopPadding - 140) / 2
    

function enableTooltip(visibilityStatus, valueFromChart){

  const divTooltip = document.getElementById("tooltip-bar")!;
  window.addEventListener('mousemove', function(event){
      const x = event.clientX;
      const y = event.clientY;
      divTooltip.style.visibility = visibilityStatus;
      divTooltip.style.left = x + "px";
      divTooltip.style.top = y + "px";
      divTooltip.style.zIndex = '1';
      divTooltip.style.fontWeight='bold';
      divTooltip.style.fontSize = "10px";
      divTooltip.style.backgroundColor='#f2f5f9';
      const chartValue = divTooltip.querySelectorAll("text")
      chartValue[0].innerHTML=(valueFromChart);
  }, false);
}

function parseData(valueString)  {
    if (valueString === undefined) {
        return [0, 0];
    }
    valueString = valueString.indexOf('|') !== -1 ? valueString : valueString + '|0';
    const values = valueString.split('|');
    const parsedValues = values.map(value => parseFloat(values[0]));

    return [
        isNaN(parsedValues[0]) ? 0 : parsedValues[0],
        isNaN(parsedValues[1]) ? 0 : parsedValues[1]
    ];
}


function arrScaleX(columns:string [][]): number[]{
  let arrScaleX: number[] = [];
  let maxValue:number = 0;
  let valueX = 0;

  columns.forEach( (x, index) => {
    const c = x.slice(Math.max(x.length-5,1));
    const value = parseData(c[index])[0];
    if(index < 5) {
      maxValue = Math.max(maxValue, value);
      scaleRating = maxValue > 1000 ? 500000 : 5;
    }
  });

  const restOfDivision = maxValue % scaleRating;
  if( restOfDivision > 0)
  {
    maxValue  = maxValue + (scaleRating - restOfDivision);
  }
  while (valueX <= maxValue) {
    arrScaleX.push(valueX);
     valueX += scaleRating;
  }
  return arrScaleX;
}

const chartWidth = ((pUiScreenWidth - 40)/2 - 15) - 130;
const space = 40;
const areaWidth = chartWidth + space;
const areaHeight = pChartHeight + 20;
const nLinhas = pRowsHeaders ? pRowsHeaders.length : 0;



  let xElements: any[] = [];
  let dataElements  = null;
  let yElements: any[] = [];
  let barElements = null;
  let xLegendValue = 10;
  let yLegendValue = 10;
  let yGridStartPosition = 0;
  let colorsElements: any[] = [];
  let labelsMap: string[] = [];
  let textElements: any[] = [];

  if (nLinhas > 0) {
    const xLabels = arrScaleX(pRowsColumns);
    const xLabelsSpace =  (chartWidth + space)/xLabels.length;
    let xValue = space;

    xElements = xLabels.map( (x, li) => {
        if(li > 0)
            xValue = xValue + xLabelsSpace;
        return (
            <text
                key={li}
                x={xValue}
                y={areaHeight - 4}
                fill="#eaeaea"
                style={{fontSize: 10}}>{x}</text>
        );
    });
    
    const columnColors = customColors ?? defaultColumnColors;
    const nEmissoras = pRowsColumns.length >= nMaxEmissoras ? nMaxEmissoras : pRowsColumns.length;
    let yElementsSpace = ((pChartHeight-(12 + (((pChartHeight-12)/nMinutes)/nEmissoras)))/nMinutes);
    let yElementsYValue = yElementsSpace;
    const yRectHeight = yElementsYValue/nEmissoras;
    let yValue = yRectHeight;
    let yMinuteSpace = (yElementsSpace)/nEmissoras;
    let emissoraSpace = yMinuteSpace;
    yGridStartPosition = yMinuteSpace;
    const headers = pRowsHeaders.length >= qtyMinutes ? pRowsHeaders.slice(0,qtyMinutes) : pRowsHeaders;

    channels?.enabled.map((column, key) => {
      labelsMap.push(column.label);
    });
 
    dataElements = pRowsColumns.map( (x, index) => {
      const c = x.slice(Math.max(x.length - 5, 1));
      if (index < nEmissoras)
      {
        const backgroundColor = columnColors[(index % columnColors.length)];
        
        colorsElements.push(
          <rect
              x={xLegendValue}
              y={yLegendValue}
              width='20px'
              height='20px'
              fill={backgroundColor}>
          </rect>
        );
        textElements.push(
          <text 
            
              id={'textElement_' + index}
              x={xLegendValue + 25}
              y={yLegendValue + 15}
              fill="#eaeaea"
              style ={{
                fontSize:'10'
              }}>
              {labelsMap[index]}
          </text>
        );
        yLegendValue += 22;
        if(index > 0)
        {
          yValue = yValue + yRectHeight;
          emissoraSpace += yMinuteSpace;
        }
        if (index == 0)
        {
          yElementsSpace += 3;
        }
        let yRectPosition = emissoraSpace;
        c.reverse();
        barElements = c.map( (cell, cellIndex) => {
          if(cellIndex < nMinutes)
          {

            if(cellIndex > 0)
            {
              yElementsYValue += yElementsSpace;
              yRectPosition += yElementsSpace;
            }

            if (index == 0)
            {
              yElements.push(
                <text
                  x={4}
                  y={yElementsYValue-10}
                  fill="#eaeaea"
                  style={{fontSize: 10}}>{headers[cellIndex][1]}
                </text>
              );
            }
            const value = parseData(cell)[0];
            const xBar = (chartWidth + space) - (value * (xLabelsSpace/scaleRating));
            const widthtBar = (chartWidth + space) - xBar;
            return (
              <rect
                key={`bar-${index}-${cellIndex}`}
                x={space+1}
                y={yRectPosition}
                width={widthtBar}
                height={yRectHeight}
                fill={backgroundColor}
                data-value={value}
                onMouseEnter={ () => enableTooltip('visible', value) } 
                onMouseLeave={() => enableTooltip('hidden', value)}/>
            );
          }
        });
      }
      return (
        <g key={`group-${index}`}>
            {barElements}
        </g>
      );
    });
  }
  return (
    <div className='BarSvg' style={{
           
           marginRight:'10px',
           float:"right"
         }}
    >
        <div
            id="tooltip-bar"
            data-testid="tooltip-bar"
            style={{
              position:'fixed',
              height:'12px',
              width:'35px',
              visibility:'hidden',
              top:'1',
              left:'1',
              marginBottom: '10px',
              marginLeft: '20px',
              color:'#000000',
              textAlign:"center",
              borderRadius: '3px'
            }}
        >
            <text></text>
        </div>
        <svg
            width={areaWidth}
            height={areaHeight}
            style={{
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                overflow: 'hidden'
            }}>
            <g id="yGrid">
              <line x1={space} x2={space} y1={yGridStartPosition} y2={pChartHeight} stroke="#eaeaea" strokeWidth="1px"></line>
            </g>
            <g id="xGrid">
              <line x1={space} x2={chartWidth + space} y1={pChartHeight} y2={pChartHeight} stroke="#eaeaea" strokeWidth="1px"></line>
            </g>
            <g id="xLabel">
              {xElements}
            </g>
            <g id="yLabels">
              {yElements}
            </g>
            <g id="dataElements">
              {dataElements}
            </g>
        </svg>
        <svg
            width={210}
            height={areaHeight}
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              overflow: 'hidden'
            }}
        >
            <g>
              {colorsElements}
            </g>
            <g>
              {textElements}
            </g>
          </svg>
    </div>
  );
}
